<template>

  <v-app>

    <v-main class="pt-0">
      <div class="at py-0 mt-0">

        <div v-for="(ava, index = ind) in avator" :key="ind">
          <v-row justify="center" class="col-12 my-3">
            <!-- 文字資訊 -->
            <v-col justify="center" class="col-12 col-lg-3">
              <v-list-item>
                <a :href="ava.src">
                  <v-list-item-avatar color="white" size="80">
                    <v-img :src="ava.img"></v-img>

                  </v-list-item-avatar>
                </a>
                <v-list-item-content>

                  <v-list-item-title><a class="font-weight-bold"
                      :style="`color:${$vuetify.theme.dark ? 'white' : 'black'}`" :href="ava.src">{{ ava.name }}</a>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-icon color="blue darken-2">mdi-label-multiple</v-icon>
                    {{ ava.tag }}
                  </v-list-item-subtitle>

                  <a :href="ava.src">
                    <v-btn v-if="ava.open" style="max-width: 100px;" rounded color="success">委託開放</v-btn>
                  </a>
                  <a :href="ava.src">
                    <v-btn v-if="!ava.open" style="max-width: 100px;" rounded color="red">暫不受理</v-btn>
                  </a>

                </v-list-item-content>
              </v-list-item>
            </v-col>

            <!-- 圖列 -->
            <v-col class=" col-12 col-lg-9 text-center">
              <v-row class="wbig">
                <v-col v-for="(img, index) in ava.small.slice(0, 5)" :key="img" class="d-flex child-flex col-2"
                  style="min-width: 20%;">
                  <v-img :src="img" aspect-ratio="1" class=" rounded-md" @click="ShowOverlay(ava.big, index)">
                  </v-img>
                </v-col>
              </v-row>
              <v-row class="wmid">
                <v-col v-for="(img, index) in ava.small.slice(0, 4)" :key="img" class="d-flex child-flex col-3"
                  style="min-width: 20%;">
                  <v-img :src="img" aspect-ratio="1" class="rounded-md" @click="ShowOverlay(ava.big, index)">
                  </v-img>
                </v-col>
              </v-row>
              <v-row class="wsma">
                <v-col v-for="(img, index) in ava.small.slice(0, 3)" :key="img" class="d-flex child-flex col-4"
                  style="min-width: 20%;">
                  <v-img :src="img" aspect-ratio="1" class="rounded-md" @click="ShowOverlay(ava.big, index)">
                  </v-img>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
          <v-divider></v-divider>
        </div>

        <v-overlay :opacity="opacity" v-if="ov" @click="ov = !ov">
          <template>
            <div class="d-flex flex-column justify-space-between align-center">
              <v-img :src="show_img" class="grey lighten-4 rounded-lg ovly">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="blue lighten-1"></v-progress-circular>
                  </v-row>
                </template>

              </v-img>

            </div>
          </template>

        </v-overlay>



      </div>

    </v-main>
  </v-app>
</template>

<script>

export default {

  components: {
  },

  data: () => ({
    ov: false,
    tab: null,

    avator: [
      //糖渣
      {
        name: "糖渣",
        tag: "立繪、頭貼、Q版、表符",
        img: "https://www.dreamcity.studio/about/images/32.jpg",
        open: "true",
        small: [
          "https://www.dreamcity.studio/art/img/sugarcrash/small/Q版/1.png",
          "https://www.dreamcity.studio/art/img/sugarcrash/small/立繪/1.png",
          "https://www.dreamcity.studio/art/img/sugarcrash/small/表符/1.jpg",
          "https://www.dreamcity.studio/art/img/sugarcrash/small/頭貼/1.png",
          "https://www.dreamcity.studio/art/img/sugarcrash/small/頭貼/2.png",
        ],
        big: [
          "https://www.dreamcity.studio/art/img/sugarcrash/big/Q版/1.png",
          "https://www.dreamcity.studio/art/img/sugarcrash/big/立繪/1.png",
          "https://www.dreamcity.studio/art/img/sugarcrash/big/表符/1.jpg",
          "https://www.dreamcity.studio/art/img/sugarcrash/big/頭貼/1.png",
          "https://www.dreamcity.studio/art/img/sugarcrash/big/頭貼/2.png",
        ],
        src: "./sugarcrash",
      },

      //兔乃
      {
        name: "兔乃",
        tag: "skin、材質包",
        img: "https://www.dreamcity.studio/art/images/rabbit.jpg",
        open: "true",
        small: [
          "https://www.dreamcity.studio/art/img/rabbitnai/small/skin/1.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/small/skin/2.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/small/材質/1.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/small/材質/2.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/small/材質/3.png",
        ],
        big: [
          "https://www.dreamcity.studio/art/img/rabbitnai/big/skin/1.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/big/skin/2.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/big/材質/1.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/big/材質/2.png",
          "https://www.dreamcity.studio/art/img/rabbitnai/big/材質/3.png",
        ],
        src: "./skin",
      },
      //唯唏
      // {
      //   name: "唯唏",
      //   tag: "Q版、半身及全身立繪、似顏繪、場景、插畫、頭貼",
      //   img: "https://www.dreamcity.studio/art/images/%E5%94%AF%E5%94%8F.jpg",
      //   open: "true",
      //   small: [
      //     "https://www.dreamcity.studio/art/img/cc/small/Q版/1.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/small/半身及全身立繪/2.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/small/場景/5.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/small/插畫/11.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/small/頭貼/3.jpg",
      //   ],
      //   big: [
      //     "https://www.dreamcity.studio/art/img/cc/big/Q版/1.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/big/半身及全身立繪/2.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/big/場景/5.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/big/插畫/11.jpg",
      //     "https://www.dreamcity.studio/art/img/cc/big/頭貼/3.jpg",
      //   ],
      //   src: "./cc",
      // },
      
      //夜瑀
      {
        name: "夜瑀",
        tag: "人物去背、人物建模、表符、壁紙、縮圖",
        img: "https://www.dreamcity.studio/about/images/34.jpg",
        open: "true",
        small: [
          "https://www.dreamcity.studio/art/img/yeiyu/small/人物去背/1.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/small/人物建模/2.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/small/表符/1.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/small/壁紙/6.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/small/縮圖/3.jpg",
        ],
        big: [
          "https://www.dreamcity.studio/art/img/yeiyu/big/人物去背/1.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/big/人物建模/2.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/big/表符/1.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/big/壁紙/6.jpg",
          "https://www.dreamcity.studio/art/img/yeiyu/big/縮圖/3.jpg",
        ],
        src: "./yeiyu",
      },



    ],


  }),

  methods: {

    ShowOverlay(big, index) {
      this.show_img = big[index];
      this.ov = !this.ov;
    },
  }

}
</script>

<style scoped>
.at {
  width: 100%;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 960px) {
  .at {
    max-width: 900px;
  }
}

@media (min-width: 1264px) {
  .at {
    max-width: 1185px;
  }
}

@media (min-width: 1704px) {
  .at {
    max-width: 1685px;
  }
}

.ovly {
  max-width: 300px;
}

@media (min-width: 700px) {
  .ovly {
    max-width: 500px;
  }
}

a {
  text-decoration: none;
}



@media (max-width: 769px) {
  .wmid {
    display: none;
  }

  .wbig {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 1263px) {
  .wbig {
    display: none;
  }

  .wsma {
    display: none;
  }

}

@media (min-width: 1264px) {
  .wsma {
    display: none;
  }

  .wmid {
    display: none;
  }

}
</style>
